module.exports = __webpack_public_path__ + "img/p-16-1.0df9cc2a.jpg";